import { CoreMenuCategoryPage } from 'src/dispensary/core-menu/category';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

CoreMenuCategoryPage.layout = CoreMenuLayout;
export default CoreMenuCategoryPage;
